/* global document */
/* eslint-disable global-require */
import React, { useState } from 'react';
import GitInfo from 'react-git-info/macro';

import CreditsOverlay from './CreditsOverlay';
import './Footer.css';
import '../Navbar/Navbar.css';

const gitInfo = GitInfo();

function Footer() {
  // STATES
  const [showCredits, setShowCredits] = useState(false);

  // FUNCTIONS
  function handleCreditsModal() {
    if (showCredits) {
      setShowCredits(false);
      document.body.style.overflow = 'visible';
    } else {
      setShowCredits(true);
      document.body.style.overflow = 'hidden';
    }
  }

  // RENDER
  return (
    <div>
      <footer>
        <div className="footer-wrapper">
          <div className="footer-links">
            <a href="https://www.hdm-stuttgart.de/impressum" target="_blank" rel="noopener noreferrer">
              Impressum
            </a>
            <a href="https://www.hdm-stuttgart.de/datenschutz" target="_blank" rel="noopener noreferrer">
              Datenschutz
            </a>
            <a href="https://www.hdm-stuttgart.de/isms" target="_blank" rel="noopener noreferrer">
              Informationssicherheit
            </a>
            <a href="https://www.hdm-stuttgart.de/barrierefreiheit" target="_blank" rel="noopener noreferrer">
              Barrierefreiheit
            </a>
            <a href="https://www.hdm-stuttgart.de/am/home/index_html" target="_blank" rel="noopener noreferrer">
              AM Studieren
            </a>
            <button type="button" className="individual-footer-link" onClick={() => handleCreditsModal()}>
              Credits
            </button>
          </div>
          <p className="footer-standard-text">
            © Hochschule der Medien 2020-2024 | Version&nbsp;
            {gitInfo.commit.shortHash}
          </p>
        </div>
      </footer>
      {showCredits ? (
        <CreditsOverlay
          showCredits={showCredits}
          setShowCredits={setShowCredits}
          handleCreditsModal={handleCreditsModal}
        />
      ) : null}
    </div>
  );
}

export default Footer;
